<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table
                            :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            @row-click="goToDetail"
                            ref="gofixTable">
                            <template slot="gofix_table:name_checklist_templates" slot-scope="row">
                                <template v-if="row.item.contract_term">
                                    <router-link target="_blank" class="text-dark" :to="`/v2/contract-client/${row.item.contract_term.contract_id}/checkList-template/${row.item.checklist_template_id}`">
                                       <span class="text-decoration-underline">{{ row.item.name_checklist_templates }}</span>
                                    </router-link>
                                </template>
                                <span class="text-decoration-underline" v-else>{{ row.item.name_checklist_templates }}</span>
                            </template>
                            <template slot="gofix_table:name" slot-scope="row">
                                <span>{{ (row.item.name != null && row.item.name.length > 50) ? row.item.name.substring(0,50)+"..." : row.item.name}}</span>
                            </template>
                            <template slot="gofix_table:unit_price" slot-scope="row">
                                {{ row.item.unit_price | formatMoney }}
                            </template>
                            <template slot="gofix_table:schedule" slot-scope="row">
                                <router-link class="text-dark" :to="`/v2/maintenance-program/${row.item.id}?tab=maint_schedule`">
                                    <span class="text-decoration-underline">View</span>
                                </router-link>
                            </template>
                            <template slot="gofix_table:actions" slot-scope="row">
                                <b-form-checkbox disabled></b-form-checkbox>
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js'

    export default {
        name: 'preventive-maintenance-program',
        components: {},
        data () {
            let filter = JSON.parse(JSON.stringify(filters['sor_master']));
            filter.is_maintenance.value = true;
            return {
                tableConfig:{
                    controls:{
                        create: null,
                        delete: null,
                        tableImport: false,
                        tableExport: false,
                    },
                    name: 'maintenance-program',
                    filter: filter,
                    useDatabaseView: true,
                    page: 1,
                    limit: 100,
                    total: 0,
                    isCMS: 1
                },
                tableItems: [],
            }
        },
        created () {},
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
            })
        },
        methods:{
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();                 
                    await this.$store.dispatch("v2SorController/getItems", tableRequest)
                        .then(response => {
                            this.tableItems = response.items;
                            this.tableConfig.total = response.total;
                            resolve(response);
                        })
                        .catch(err => {
                            this.$alertNotification("Can not load the maintenance program list", "danger");
                            reject();
                        })
                },
            goToDetail(item){
                let id = item.id || 0;
                return this.$router.push(`/v2/maintenance-program/${id}`);
            },
        }
    }
</script>
